<template>
  <div class="error-page">
    <div id="notfound">
      <div class="notfound">
        <div class="notfound-404">
          <h1 v-html="codeText"></h1>
        </div>
        <p>
          {{ message }}
        </p>
        <el-button type="primary" 
          @click="$router.push(url || {name: 'index'})"
          icon="el-icon-arrow-left"
        >
          {{ btnText || 'Home Page' }}
        </el-button>
        <!-- <router-link :to=""></router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: [
    'code',
    'url',
    'btnText',
    'customMessage'
  ],

  mounted(){
    //
    $(document).ready(() => {
      $('body').addClass('bg-1 error-page')
    })
  },

  computed: {
    message() {
      if (this.customMessage && this.customMessage !== '') {
        return this.customMessage;
      }

      switch (this.code) {
        case 404:
          return `The page you are looking for might have been removed had 
            its name changed or is temporarily unavailable.`;
        case 503:
          return `The server is currently unable to handle the request due to a 
          temporary overloading or maintenance of the server. The implication is that 
          this is a temporary condition which will be alleviated after some delay.`
        default:
          return null;
      }
    },

    codeText() {
      return this.code.replace('0', '<span>0</span>');
    }
  },

  watch: {
  }
}
</script>

<style lang="scss">
.error-page {

  #notfound {
    position: absolute;
    height: 100vh;
    // background-color: #222;
    width: 100%;
    left: 0;
    top: 50px;
  }

  #notfound .notfound {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
  }

  .notfound {
    max-width: 460px;
    width: 100%;
    text-align: center;
    line-height: 1.4;
  }

  .notfound .notfound-404 {
    height: 238px;
    line-height: 228px;
  }

  .notfound .notfound-404 h1 {
    font-family: 'Josefin Sans', sans-serif;
    color: #222;
    font-size: 220px;
    letter-spacing: 10px;
    margin: 0px;
    font-weight: 700;
    text-shadow: 2px 2px 0px #c9c9c9, -2px -2px 0px #c9c9c9;
  }

  .notfound .notfound-404 h1>span {
    text-shadow: 2px 2px 0px #C70C13, -2px -2px 0px #C70C13, 0px 0px 8px rgb(231, 10, 17);
  }

  .notfound p {
    font-family: 'Josefin Sans', sans-serif;
    color: #c9c9c9;
    font-size: 16px;
    font-weight: 400;
    margin-top: 0px;
    margin-bottom: 15px;
  }

  .notfound a {
    font-family: 'Josefin Sans', sans-serif;
    font-size: 14px;
    text-decoration: none;
    text-transform: uppercase;
    background: transparent;
    color: #c9c9c9;
    border: 2px solid #c9c9c9;
    display: inline-block;
    padding: 10px 25px;
    font-weight: 700;
    -webkit-transition: 0.2s all;
    transition: 0.2s all;
  }

  .notfound a:hover {
    color: #C70C13;
    border-color: #C70C13;
  }

  @media only screen and (max-width: 480px) {
    .notfound .notfound-404 {
      height: 122px;
      line-height: 122px;
    }

    .notfound .notfound-404 h1 {
        font-size: 122px;
    }
  }
}
</style>